import * as types from './type';

import { Agent }  from  '../../services/agent';

export function getAgents(post) {
    return {
      type: types.GET_AGENTS,
      payload: Agent.getAgents(post),
    };
};

